export function removeEmptyValues<T extends object>(obj: T): Partial<T> {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.length > 0 ? obj : (undefined as any);
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (value === null || value === undefined || value === '') {
      return acc;
    }

    if (typeof value === 'object') {
      const cleanedValue = removeEmptyValues(value as object);

      if (
        cleanedValue !== undefined &&
        cleanedValue !== null &&
        Object.keys(cleanedValue).length > 0
      ) {
        acc[key as keyof T] = cleanedValue as any;
      }
      return acc;
    }

    acc[key as keyof T] = value;
    return acc;
  }, {} as Partial<T>);
}
